import React from "react";
import "./LoadingSpinner.css";
const LoadingSpinner = () => {
  return (
    <div className="flex flex-col justify-center items-center min-h-[calc(100vh-8rem)] gap-2">
      <div className="loader -mt-[2.5rem]"></div>
    </div>
  );
};

export default LoadingSpinner;
